"use client";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar";
import { coverForId } from "@/lib/image/covers";
import { cn } from "@/lib/utils";

/** Tiny project cover thumb — matches navbar project-select avatar treatment. */
export function ProjectCoverAvatar({
  projectId,
  coverImageUrl,
  className,
}: {
  projectId?: string | null;
  coverImageUrl?: string | null;
  className?: string;
}) {
  if (!projectId && !coverImageUrl) {
    return (
      <div
        className={cn("size-3.5 shrink-0 rounded-sm bg-contrast/10", className)}
        aria-hidden
      />
    );
  }

  return (
    <Avatar className={cn("size-3.5 shrink-0 rounded-sm", className)}>
      <AvatarImage src={coverImageUrl ?? undefined} alt="" />
      <AvatarFallback className="rounded-sm p-0 bg-transparent">
        {projectId ? (
          // eslint-disable-next-line @next/next/no-img-element -- local /public preset covers
          <img
            src={coverForId(projectId)}
            alt=""
            className="size-full object-cover"
          />
        ) : (
          <div className="size-full bg-contrast/10" />
        )}
      </AvatarFallback>
    </Avatar>
  );
}
